export async function getCountryMapBounds(names, token, signal) {
    if (!token || !names.length)
        return null;
    const boxes = await Promise.all([...new Set(names.filter(Boolean))].map(async (name) => {
        var _a, _b, _c, _d, _e, _f;
        const url = `https://api.mapbox.com/search/geocode/v6/forward?q=${encodeURIComponent(name)}&types=country&autocomplete=false&language=ru&limit=1&access_token=${encodeURIComponent(token)}`;
        const response = await fetch(url, { signal });
        if (!response.ok)
            return null;
        const data = await response.json();
        const box = (_d = (_c = (_b = (_a = data.features) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.properties) === null || _c === void 0 ? void 0 : _c.bbox) !== null && _d !== void 0 ? _d : (_f = (_e = data.features) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.bbox;
        return Array.isArray(box) && box.length === 4 && box.every(Number.isFinite) ? box : null;
    }));
    const valid = boxes.filter((box) => box !== null);
    return valid.length ? [Math.min(...valid.map(b => b[0])), Math.min(...valid.map(b => b[1])), Math.max(...valid.map(b => b[2])), Math.max(...valid.map(b => b[3]))] : null;
}
